export { CheckoutTemplate } from './CheckoutTemplate';
export type { CheckoutTemplateLabels, CheckoutTemplateProps } from './CheckoutTemplate.types';
